<template>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :id="slug"
             :fields="fields"
             :items="items"
             primary-key="id"
             :busy="isLoading"
             label-sort-asc=""
             label-sort-desc=""
             sort-by="skillTestDate"
             sort-desc="true"
             caption="Testing History Table. To sort data in this table click on the field in the header. Click again to sort descending.">
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:empty="scope">
            <p>No testing history found.</p>
        </template>
        <template v-slot:cell(skillTestDate)="row">
            {{formatDate(row.item.skillTestDate)}}
        </template>
        <template v-slot:cell(knowledgeTestDate)="row">
            {{formatDate(row.item.knowledgeTestDate)}}
        </template>
        <template v-slot:cell(trainingDate)="row">
            {{formatDate(row.item.trainingDate)}}
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
        </div>
    </b-table>
</template>

<script>
    import moment from 'moment';
    export default {
        name: "TestingHistoryTableList",

        props: {
            items: Array,
            slug: [String],
            isLoading: Boolean,
        },
        data: () => ({
            fields: [
                {key: 'skillTestDate', sortable: true, label: 'Skill Test Date'},
                {key: 'knowledgeTestDate', sortable: true, label: 'Knowledge Test Date'},
                {key: 'trainingDate', sortable: true, label: 'Training Date'},
                {key: 'testOut', sortable: true, label: 'Test Out'},
                {key: 'trainingHrs', sortable: true, label: 'Training Hours'}

            ]
        }),
        methods:{
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
        }
    }
</script>

<style scoped>

</style>